// MKT-#12: shared "where do we send the user after auth" resolver, used by the
// magic-link redeem and the /sign-in authenticated-visitor guard. Only same-
// origin absolute paths are honored, so a crafted ?from=//evil.com or
// ?from=https://evil.com can never turn into an open redirect - anything else
// falls back to the dashboard.

export function safeReturnPath(from: string | null | undefined): string {
  if (from && from.startsWith("/") && !from.startsWith("//")) return from;
  return "/dashboard";
}
